import { transType } from 'utils/static'

// Trans type → key default akun pembayaran di config.account_mapping_defaults (init finance).
// Tambah trans type lain di sini kalau BE menambah mapping-nya.
export const PAYMENT_ACCOUNT_MAPPING = {
  [transType.ORDER]: 'sales_order_payment_account',
  [transType.INVOICE]: 'sales_invoice_payment_account',
}

// Trans type → key default akun uang muka.
export const DOWN_PAYMENT_ACCOUNT_MAPPING = {
  [transType.ORDER]: 'sales_down_payment_account',
  [transType.INVOICE]: 'sales_down_payment_account',
}

// Trans type kalau semua baris terpilih sama, selain itu undefined (mis. tagihan + join invoice).
export const getSameTransTypeId = (rows) => {
  const transTypeIds = new Set((rows || []).map((row) => row?.trans_type_id))
  return transTypeIds.size === 1 ? [...transTypeIds][0] : undefined
}

// Ambil akun default trans type dari config.account_mapping_defaults, lalu lengkapi nama dan
// kode dari daftar akun bank init. Trans type tanpa mapping atau akun tanpa akses return null.
export const findMappingAccount = (defaults, bankAccounts, transTypeId, isDownPayment = false) => {
  const mapping = isDownPayment ? DOWN_PAYMENT_ACCOUNT_MAPPING : PAYMENT_ACCOUNT_MAPPING
  const key = mapping[transTypeId]
  const id = key ? defaults?.[key] : null
  if (!id || !Array.isArray(bankAccounts)) {
    return null
  }

  const account = bankAccounts.find((row) => row?.id === id)
  if (!account) {
    return null
  }

  return { id: account.id, name: account.name, ref_code: account.ref_code }
}

// Ubah payload Pemetaan Akun ({ mapping_<key>: akun }) ke bentuk account_mapping_defaults.
export const toAccountMappingDefaults = (mappingAccounts) => {
  const keys = new Set([
    ...Object.values(PAYMENT_ACCOUNT_MAPPING),
    ...Object.values(DOWN_PAYMENT_ACCOUNT_MAPPING),
  ])
  const result = {}
  keys.forEach((key) => {
    const id = mappingAccounts?.[`mapping_${key}`]?.id
    if (id) {
      result[key] = id
    }
  })

  return result
}
